import { useState } from "react";
import "./App.css";
import Item from "./components/item";
import ReactPlayer from "react-player";
import {motion} from "framer-motion";
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import { EffectFade, Autoplay } from "swiper/modules";
import { toggleLanguage } from "../src/components/langueslice.js";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";


function App() {
  const [count, setCount] = useState(0);
    const [produit, setProduit] = useState([]);
  
    const langue = useSelector((state) => state.langue.value);
    const dispatch = useDispatch();
    const { t } = useTranslation();
  
    const handleLangChange = () => {
      dispatch(toggleLanguage());
    };

  const images = [
    
    "https://res.cloudinary.com/dkxjl9qii/image/upload/v1740833475/posts/gqy43egcs8obqrntap6t.jpg",
    "https://res.cloudinary.com/dkxjl9qii/image/upload/v1740834387/posts/kyit6z0yki6gclhzxpeb.jpg",
    "https://res.cloudinary.com/dkxjl9qii/image/upload/v1740833685/posts/zvfd1pwopyflstv42zet.jpg",
    "https://res.cloudinary.com/dkxjl9qii/image/upload/v1740834468/posts/yn0mlseb6yvcgsmw8x5s.jpg",
    "https://res.cloudinary.com/dkxjl9qii/image/upload/v1740833797/posts/yzjwg3l0bq41s4gmmqcg.jpg",
    "https://res.cloudinary.com/dkxjl9qii/image/upload/v1740834547/posts/yqylpcv4idqvgabtt4qg.jpg",
   
  ];
  

 const getproducts = async () => {
     try {
       const response = await fetch("https://antar-5byu.onrender.com/getposts", {
         method: "GET",
       });
 
       if (!response.ok) {
         const errorResult = await response.json().catch(() => ({ message: "Unknown error" }));
         alert("Erreur: " + errorResult.message || "Échec de la récupération des produits.");
         return;
       }
 
       const result = await response.json();
       setProduit(result);
     } catch (error) {
       console.error("Erreur produit:", error);
       alert("Erreur: Une erreur s'est produite. Veuillez réessayer.");
     }
   };
 
   
   useEffect(() => {
     getproducts();
   }, []);
  

  return (
    <div className="bg-gray-300 w-full">
     
    <div className="relative w-full h-56 sm:h-80 lg:h-96">
      {/* Swiper Container */}
      <Swiper
        modules={[EffectFade, Autoplay]}
        effect="fade"
        autoplay={{ delay: 5000 }}
        loop
        className="w-full h-full"
      >
        {images.map((src, index) => (
          <SwiperSlide key={index}>
          <img
  src={`${src}?q_100,f_auto,w_1920`}
  className="w-full h-full object-cover"
  alt={`Slide ${index}`}
/>
<h1 className={`absolute text-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-gray-200 ${langue === "fr" ? "text-2xl" : "text-4xl"} sm:text-4xl font-bold`}>
  {langue === "fr" ? "Explorez une sélection de nos créations" : "اكتشف مجموعة من إبداعاتنا"}
</h1>

          </SwiperSlide>
        ))}
      </Swiper>

    </div>
      {/* Image de couverture 
      <img
        className=" h-56 sm:h-80 lg:h-96 w-full object-cover"
        src="../src/assets/R.jpg"
        alt="Image"
      />*/}

      {/* Titre */}
      <h1
  id="titre"
  className={`text-gray-700 ${langue === "ar" ?"max-sm:text-2xl":"max-sm:text-lg"}  max-sm:px-2 font-bold text-center text-2xl my-6 drop-shadow-lg ${
    langue === "ar" ? "text-4xl" : "text-2xl"
  }`}
>
  {langue === "fr" ? (
    <>
      Découvrez l'authenticité des épices
      <span className="text-green-700"> Qualité </span> et <span className="text-green-700">saveurs</span> venues d'ailleurs, livrées chez vous.
    </>
  ) : (
    <>
      اكتشف أصالة التوابل
      <span className="text-green-700"> الجودة </span> و <span className="text-green-700">النكهات</span> القادمة من أماكن أخرى، يتم توصيلها إليك.
    </>
  )}
</h1>

         {/* Conteneur centré */}
         <div className="flex justify-center">
        {/* Grille centrée */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-6">
        {produit.map((pro) => (
            <Item
              key={pro._id}
              id={pro._id}
              title={pro.title}
              prix={pro.prix}
              description={pro.description}
              image={pro.picturePaths?.[0]} // Prendre la première image
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;